<template>
  <div class="Daily_report">
    <h2>
      受严重心理困扰，在这里是指学生实际出现或高度疑似出现自杀或者他杀的想法、倾向、冲动、行动。在这种情况下当事人可能的表现可能包括但不限于
    </h2>
    <h6>
      1.学生实际出现或高度疑似出现自杀或者伤害他人的想法、倾向冲动、行动；
    </h6>
    <h6>2.学生实际出现或高度疑似出现幻觉、妄想等严重精神障碍症状。</h6>
    <!-- <h6>（3）近期出现过以结束自己/他人生命为目的的行动。</h6> -->
    <h2>
      如果您不确定自己观察到的情况是否属于以上几种情况，但又确实对某位当事人的心理状态感到很担忧，我们仍支持您进行预防性上报，将有专业人士来跟进评估。
    </h2>
    <el-form
      style="width: 32%; min-width: 500px"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <h2 style="font-size: 20px; margin-left: 20px; padding-bottom: 20px">
        "五困"类型及具体表现
      </h2>

      <el-form-item
        class="difficulty"
        style="position: relative"
        label="学习困扰"
      >
        <el-checkbox-group
          :max="3"
          v-model="ruleForm.studyDifficulty"
          @change="difficulty_other1()"
        >
          <el-checkbox label="1" name="type">学业基础薄弱</el-checkbox>
          <el-checkbox label="2" name="type">学习能力差</el-checkbox>
          <el-checkbox label="3" name="type">科研能力差</el-checkbox>
          <el-checkbox label="4" name="type">缺乏专业兴趣</el-checkbox>
          <el-checkbox label="5" name="type">第一次挂科</el-checkbox>
          <el-checkbox label="6" name="type">多门挂科</el-checkbox>
          <el-checkbox label="7" name="type">缺课缺考</el-checkbox>
          <el-checkbox label="8" name="type">留级延期</el-checkbox>
        </el-checkbox-group>

        <el-input
          style="width: 200px; position: absolute; top: 2px; right: -10px"
          v-model="ruleForm.studyDifficultyOther"
          placeholder="请输入学习困扰"
        ></el-input>
      </el-form-item>

      <el-form-item
        class="difficulty"
        style="position: relative"
        label="生活困扰"
      >
        <el-checkbox-group
          :max="3"
          v-model="ruleForm.lifeDifficulty"
          @change="difficulty_other2()"
        >
          <el-checkbox label="1" name="type">经济困难</el-checkbox>
          <el-checkbox label="2" name="type">未获助学贷款</el-checkbox>
          <el-checkbox label="3" name="type">家庭重大变故</el-checkbox>
          <el-checkbox label="4" name="type">严重躯体疾病</el-checkbox>
          <el-checkbox label="5" name="type">生活自理困难</el-checkbox>
          <el-checkbox label="6" name="type">身体缺陷</el-checkbox>
          <el-checkbox label="7" name="type">语言困难</el-checkbox>
          <el-checkbox label="8" name="type">被骗被控制</el-checkbox>
        </el-checkbox-group>
        <el-input
          style="width: 200px; position: absolute; top: 2px; right: -40px"
          v-model="ruleForm.lifeDifficultyOther"
          placeholder="请输入生活困难"
        ></el-input>
      </el-form-item>

      <el-form-item
        class="difficulty"
        label="交往困扰"
        style="position: relative"
      >
        <el-checkbox-group
          :max="3"
          v-model="ruleForm.contactDifficulty"
          @change="difficulty_other3()"
        >
          <el-checkbox label="1" name="type">内向孤僻</el-checkbox>
          <el-checkbox label="2" name="type">退缩回避</el-checkbox>
          <el-checkbox label="3" name="type">适应不良</el-checkbox>
          <el-checkbox label="4" name="type">同学关系不良</el-checkbox>
          <el-checkbox label="5" name="type">师生关系不良</el-checkbox>
          <el-checkbox label="6" name="type">亲密关系不良</el-checkbox>
          <el-checkbox label="7" name="type">家庭关系不良</el-checkbox>
          <el-checkbox label="8" name="type">遭遇欺凌等</el-checkbox>
        </el-checkbox-group>

        <el-input
          v-model="ruleForm.contactDifficultyOther"
          style="width: 200px; position: absolute; top: 2px; right: -40px"
          placeholder="请输入交往困难"
        ></el-input>
      </el-form-item>

      <el-form-item
        class="difficulty"
        label="发展困扰"
        style="position: relative"
      >
        <el-checkbox-group
          :max="3"
          v-model="ruleForm.developDifficulty"
          @change="difficulty_other4()"
        >
          <el-checkbox label="1" name="type">深感自卑</el-checkbox>
          <el-checkbox label="2" name="type">思想偏激</el-checkbox>
          <el-checkbox label="3" name="type">发展迷茫</el-checkbox>
          <el-checkbox label="4" name="type">过高期待</el-checkbox>
          <el-checkbox label="5" name="type">毕业困难</el-checkbox>
          <el-checkbox label="6" name="type">考研失败</el-checkbox>
          <el-checkbox label="7" name="type">就业困难</el-checkbox>
          <el-checkbox label="8" name="type">创业失败</el-checkbox>
        </el-checkbox-group>
        <el-input
          v-model="ruleForm.developDifficultyOther"
          style="width: 200px; position: absolute; top: 2px; right: 90px"
          placeholder="请输入发展困难"
        ></el-input>
      </el-form-item>

      <el-form-item
        class="difficulty"
        label="心理困扰"
        style="position: relative"
      >
        <el-checkbox-group
          :max="3"
          v-model="ruleForm.psyDifficulty"
          @change="difficulty_other5()"
        >
          <el-checkbox label="1" name="type">自杀伤人倾向</el-checkbox>
          <el-checkbox label="2" name="type">重性精神病</el-checkbox>
          <el-checkbox label="3" name="type">应激危机</el-checkbox>
          <el-checkbox label="4" name="type">人格问题</el-checkbox>
          <el-checkbox label="5" name="type">情绪障碍</el-checkbox>
          <el-checkbox label="6" name="type">成瘾行为</el-checkbox>
          <el-checkbox label="7" name="type">进食问题</el-checkbox>
          <el-checkbox label="8" name="type">睡眠问题</el-checkbox>
        </el-checkbox-group>
        <el-input
          v-model="ruleForm.psyDifficultyOther"
          style="width: 200px; position: absolute; top: 2px; right: 40px"
          placeholder="请输入心理困难"
        ></el-input>
      </el-form-item>

      <el-form-item label="自杀他杀风险详情" prop="difficultDetail">
        <el-input
          style="height: 100px"
          type="textarea"
          v-model="ruleForm.difficultDetail"
        ></el-input>
      </el-form-item>
      <p
        style="
          margin-left: 20px;
          padding-top: 10px;
          color: #5c5c5c;
          padding-bottom: 20px;
        "
      >
        为了方便在需要时联系您，请您在下方留下联系信息
      </p>
      <el-form-item label="紧急联系人">
        <el-input v-model="ruleForm.urgentContact"></el-input>
      </el-form-item>
      <el-form-item label="关系">
        <el-input v-model="ruleForm.relation"></el-input>
      </el-form-item>
      <el-form-item label="紧急联系人方式">
        <el-input v-model="ruleForm.urgentContactPhone"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          :loading="ruleFormpd"
          type="primary"
          @click="submitForm('ruleForm', 1)"
          >提交</el-button
        >
        <el-button @click="submitForm('ruleForm', 2)">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      roleID: "",
      Search_content: "",
      data: [],
      ruleFormpd: false,
      other1: false, //其他是否显示
      other2: false, //其他是否显示
      other3: false, //其他是否显示
      other4: false, //其他是否显示
      other5: false, //其他是否显示
      userIdlist: [],
      ruleForm: {
        alertName: JSON.parse(sessionStorage.getItem("xinxi")).RealName, //学生姓名
        alertPhone: JSON.parse(sessionStorage.getItem("xinxi")).Phone, //学生姓名
        difficultDetail: "", //自杀他杀风险详情
        urgentContact: "", //紧急联系人
        urgentContactPhone: "", //紧急联系方式
        relation: "", //关系
        studyDifficulty: [], //学生困难
        lifeDifficulty: [], //生活困难
        contactDifficulty: [], //交往困难
        developDifficulty: [], //发展困难
        psyDifficulty: [], //心理困难
        type: "1",
        studyDifficultyOther: "",
        lifeDifficultyOther: "",
        contactDifficultyOther: "",
        developDifficultyOther: "",
        psyDifficultyOther: "",
      },
      rules: {
        userId: [
          { required: true, message: "请选择活动区域", trigger: "change" },
        ],
        alertName: [
          { required: true, message: "请输入预警者姓名", trigger: "change" },
        ],
        alertPhone: [
          { required: true, message: "请输入预警者电话", trigger: "change" },
        ],
        difficultDetail: [
          {
            required: true,
            message: "请输入自杀他杀风险详情",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    ss(val) {
      this.Search_content = val;
    },
    Search() {
      this.$Http_Post("/DistressPrediction/InterviewRecordEcho", {
        userId: this.Search_content,
        type: "1",
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Search_content = "";
          this.userIdlist = res.Data.list;
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    difficulty_other1() {
      for (let i = 0; i <= this.ruleForm.studyDifficulty.length; i++) {
        if (this.ruleForm.studyDifficulty[i] == 9) {
          this.other1 = true;
          return false;
        } else {
          this.other1 = false;
        }
      }
    },
    difficulty_other2() {
      for (let i = 0; i <= this.ruleForm.lifeDifficulty.length; i++) {
        if (this.ruleForm.lifeDifficulty[i] == 9) {
          this.other2 = true;
          return false;
        } else {
          this.other2 = false;
        }
      }
    },
    difficulty_other3() {
      for (let i = 0; i <= this.ruleForm.contactDifficulty.length; i++) {
        if (this.ruleForm.contactDifficulty[i] == 9) {
          this.other3 = true;
          return false;
        } else {
          this.other3 = false;
        }
      }
    },
    difficulty_other4() {
      for (let i = 0; i <= this.ruleForm.developDifficulty.length; i++) {
        if (this.ruleForm.developDifficulty[i] == 9) {
          this.other4 = true;
          return false;
        } else {
          this.other4 = false;
        }
      }
    },
    difficulty_other5() {
      for (let i = 0; i <= this.ruleForm.psyDifficulty.length; i++) {
        if (this.ruleForm.psyDifficulty[i] == 9) {
          this.other5 = true;
          return false;
        } else {
          this.other5 = false;
        }
      }
    },
    resetssForm() {
      this.$router.push("/Crisis/Crisis_addmajor_event");
    },
    xs() {
      for (let i = 0; i < this.userIdlist.length; i++) {
        if (this.ruleForm.userId == this.userIdlist[i].userId) {
          this.ruleForm.realName = this.userIdlist[i].realName;
          this.ruleForm.deptId = this.userIdlist[i].deptName;
          this.ruleForm.userIds = this.userIdlist[i].userId;
          this.ruleForm.userId = this.userIdlist[i].userId;
        } else {
        }
      }
    },
    xs2() {
      for (let i = 0; i < this.userIdlist.length; i++) {
        if (this.Search_content == this.userIdlist[i].userId) {
          this.ruleForm.realName = this.userIdlist[i].realName;
          this.ruleForm.deptId = this.userIdlist[i].deptName;
          this.ruleForm.userIds = this.userIdlist[i].userId;
          this.ruleForm.userId = this.userIdlist[i].userId;
        } else {
        }
      }
    },
    submitForm(formName, operate) {
      this.$refs[formName].validate((valid) => {
        //提交按钮
        if (valid) {
          this.ruleFormpd = true;
          this.$Http_Post("/DistressPrediction/AddDailyCrisisApp", {
            form: this.ruleForm,
          }).then((res) => {
            if (res.Code == 0) {
              this.Global.request_successful(res.Message);
              this.ruleFormpd = false;
            } else {
              this.ruleFormpd = false;
              this.Global.request_failure(res.Message);
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted: function () {
    this.roleID = sessionStorage.getItem("RoleID");
    this.$Http_Post("/DistressPrediction/DropDownBox", {
      roleID: sessionStorage.getItem("RoleID"),
    }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.userIdlist = res.Data;
      }
    });
  },
};
</script>

<style>
.Daily_report {
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: auto;
}
.Daily_report h2 {
  font-size: 20px;
  margin-left: 20px;
  padding-top: 20px;
  line-height: 40px;
}
.Daily_report h6 {
  font-size: 18px;
  margin-left: 20px;
  line-height: 40px;
}
.Daily_report .el-form-item__content {
  margin-left: 160px !important;
}
.Daily_report .el-form-item__label {
  width: 160px !important;
}
.Daily_report .el-textarea__inner {
  height: 100px;
}
.Daily_report .difficulty {
  width: 1400px !important;
}
</style>